module.exports = __webpack_public_path__ + "img/globe.67865adb.svg";